import { successNotifyService, failureNotifyService } from '@/services/errors.service.js';
import { isInteger } from 'core-js/fn/number';
import { isBoolean } from 'lodash';

export function checkInputFieldService(localData, action) {
    let cfObj = {};

    //////////////////////////////////////
    /// Users Collection
    //////////////////////////////////////

    if (action === "savePROrganization") {
        cfObj.fieldName = 'organization';
        cfObj.fieldValueIsNull = false; // this field can be null
        cfObj.collectionName = 'projects';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === "savePRTitle" && localData.title) {
        cfObj.fieldName = 'title';
        cfObj.fieldValueIsNull = false;
        cfObj.collectionName = 'projects';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === 'savePRDescription') {
        cfObj.fieldName = 'description';
        cfObj.fieldValueIsNull = false; // this field can be null
        cfObj.collectionName = 'projects';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else {
        cfObj.fieldName = null;
        cfObj.fieldValueIsNull = true;
        cfObj.collectionName = null;
        cfObj.vuexServiceName = null;
        return cfObj;
    }

}

export function saveInputFieldService(payload) {

    const isUserLoggedIn = payload.isUserLoggedIn;
    const action = payload.action;
    const currentThis = payload.currentThis;
    const localData = payload.localData;
    const projectId = payload.projectId;

    const cfObj = checkInputFieldService(localData, action);
    
    // // console.log(cfObj, payload);

    if (!isUserLoggedIn || cfObj.fieldValueIsNull) {
        return;
    }

    currentThis.$store.commit("editor/TOGGLE_SAVE_IN_PROGRESS", true);

    // // console.log("executing...", localData);

    const fieldName = cfObj.fieldName;
    const vuexServiceName = cfObj.vuexServiceName;

    const dataObj = {};
    dataObj["_id"] = projectId;
    dataObj['collectionName'] = cfObj.collectionName;

    if (localData[`${fieldName}`]) { // If field value is not null
        
        if(isInteger(localData[`${fieldName}`])) {
            dataObj[`${fieldName}`] = Number(localData[`${fieldName}`].toString().trim());
        } if(isBoolean(localData[`${fieldName}`])) {
            dataObj[`${fieldName}`] = Boolean(localData[`${fieldName}`].toString().trim());
        } else {
            dataObj[`${fieldName}`] = localData[`${fieldName}`].trim();
        }

    } else dataObj[`${fieldName}`] = null; // If field value is null

    //// console.log(dataObj);

    currentThis.$store
        .dispatch(`${vuexServiceName}/${action}`, dataObj)
        .then((res) => {
            currentThis.$store.commit(
                "editor/TOGGLE_SAVE_IN_PROGRESS",
                false
            );
            //// console.log(res);
        })
        .catch((err) => {
            throw err;
        });
}

export function deleteDocumentService(payload) {
    const currentThis = payload.currentThis;
    const projectId = payload.projectId;

    currentThis.$store.dispatch('editor/deleteProject', projectId).then((res) => {
        successNotifyService({currentThis, title: 'Project Deleted', text: 'This Project has been successfully deleted.'})
    }).catch(err => {
        throw err;
    })
}


export function updateImageService(payload) {

    const imgInput = payload.imgInput;
    const userId = payload.userId;
    const projectId = payload.projectId;
    const currentThis = payload.currentThis;
    const maxSize = payload.maxSize; // In MB

    if (imgInput.target.files && imgInput.target.files[0]) {
        if (imgInput.target.files > 1) {
            return;
        }

        const parts = imgInput.target.files[0].name.split(".");
        const ext = parts[parts.length - 1];

        //////////////////////////////////////////
        // Check for correct image file type
        //////////////////////////////////////////

        if (ext !== "jpg" && ext !== "jpeg" && ext !== "png") {

            const payload = {
                title: "Incorrect File Type",
                text: "Please upload a supported image file type, e.g. jpg, png, etc.",
                currentThis
            }

            failureNotifyService(payload);

            return;
        }

        //////////////////////////////////////////
        // Check for image file size
        //////////////////////////////////////////

        if (imgInput.target.files[0].size / (1024*1024) > maxSize) {

            const payload = {
                title: "Image File Size Exceeded",
                text: "The size of the project picture should be less than 3MB.",
                currentThis
            }

            failureNotifyService(payload);

            return;
        }

        currentThis.$store.commit("editor/TOGGLE_SAVE_IN_PROGRESS", true);

        currentThis.$vs.loading({
            container: "#upload-project-picture",
            color: "primary",
            background: "white",
            scale: 0.45,
        });

        const reader = new FileReader();
        reader.onload = (e) => {
            const projectPictureData = e.target.result;
            const projectPictureUrl = projectId + "-" + userId + "." + ext;

            const ppObj = {
                projectPictureData,
                projectPictureUrl,
            };

            // // console.log(ppObj);

            currentThis.$store
                .dispatch("editor/updateProjectPicture", {
                    ppObj,
                    projectId,
                })
                .then((res) => {
                    currentThis.$store.commit("editor/TOGGLE_SAVE_IN_PROGRESS", false);
                    currentThis.localData.projectPictureUrl = res.data.projectPictureUrl;
                    currentThis.$forceUpdate();
                    currentThis.$vs.loading.close(
                        "#upload-project-picture > .con-vs-loading"
                    );
                })
                .catch((err) => {
                    throw err;
                });
        };
        reader.readAsDataURL(imgInput.target.files[0]);
    }
}